module.exports = __webpack_public_path__ + "img/lincplus_01.8d2cf802.png";